export enum FilterTypes {
  PassedQualification = 'passedQualification',
  MissingLegPoints = 'missingLegPoints',
  None = 'none',
}
